var map = {
	"./customer_active.svg": "1f3a",
	"./customer_g_active.svg": "8dc0",
	"./customer_g_inactive.svg": "8c70",
	"./customer_inactive.svg": "9a96",
	"./home_active.svg": "6277",
	"./home_inactive.svg": "03d9",
	"./task_active.svg": "ba59",
	"./task_inactive.svg": "0195"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7b3d";